import { gql } from '@apollo/client';

export const FILTERED_ECD_DISTRICTS = gql`
  query filteredECDDistricts($input: DistrictInput) {
    districts: filteredECDDistricts(input: $input) {
      id
      name
    }
  }
`;
